import HoneypotIndicator from './HoneypotIndicator';
import HoneypotRearmButton from './HoneypotRearmButton';

// #207 parte 2 — el indicador (y, para admin, el botón «Rearmar honeypots») sólo
// aplica a jobs de archivos: los demás no llevan honeypots. `status` es el
// honeypot_status guardado del job.
export default function JobHoneypotProtection({ jobType, status, jobId, agentVersion, running = false, onChanged }) {
  if (jobType !== 'files') return null;
  const actions = jobId
    ? <HoneypotRearmButton jobId={jobId} agentVersion={agentVersion} running={running} onChanged={onChanged} />
    : null;
  return <HoneypotIndicator status={status} actions={actions} />;
}
